module.exports = __webpack_public_path__ + "static/media/friozem.89bc4c1a.png";